/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import { Typography } from '@mui/material';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import AppForm from './AppForm';
import { getAllApplication } from '../../../../../../store/reducers/application/applicationAction';
import { createApplication } from '../../../../../../services/application/Application';

const AppCreation = ({ handleClose }) => {
    const dispatch = useDispatch()
    const handleSubmit = async ({ applicationName }) => {
        try {
            await createApplication({ applicationName });
            toast.success('Application was registred successfully');
            handleClose();
            await dispatch(getAllApplication()).unwrap();
        } catch (error) {
            toast.error(error?.response?.data?.error?.message);
        }
    }

    return (
        <>
            <Typography variant='h2' color="primary" align='center' style={{ margin: '30px' }}>Application Registration</Typography>
            <Formik
                initialValues={{
                    applicationName: ''
                }}
                validationSchema={Yup.object().shape({
                    applicationName: Yup.string().min(2).max(40).required('Application Name is required.')
                })}
                onSubmit={(
                    values
                ) => {
                    handleSubmit(values)
                }
                }
            >
                {({ values, handleBlur, handleChange, isSubmitting, setFieldValue, errors, touched }) => (
                    <AppForm
                        values={values}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        setFieldValue={setFieldValue}
                        isSubmitting={isSubmitting}
                        handleClose={handleClose}
                        errors={errors}
                        touched={touched} />
                )}
            </Formik>
        </>
    )

}


export default AppCreation;